import React, { createContext } from "react"

export const PageLocationContext = createContext("/")

// Gatsby supplies the same pathname during static rendering and navigation.
export const wrapPageElement = ({ element, props }) => (
  <PageLocationContext.Provider value={props.location.pathname}>
    {element}
  </PageLocationContext.Provider>
)
